export default {
    resalesLanding: {
        sentOn: "Sendt den",
        toggleContact: "Vis/skjul meglerens kontaktinformasjon",
        propertyOffers: "Boligtilbud",
        openGallery: "Åpne bildegalleri",
        prevPhoto: "Forrige bilde",
        nextPhoto: "Neste bilde",
        close: "Lukk",
        photo: "Bilde",
        description: "Beskrivelse",
        more: "Mer",
        less: "Mindre",
        intFloorSpace: "Boareal",
        build: "Bebygd",
        terrace: "Terrasse",
        garden: "Hage",
        buildYear: "Byggeår",
        fees: "Kostnader",
        communityFees: "Felleskostnader",
        basuraTax: "Renovasjonsavgift (Basura)",
        ibiFees: "IBI (eiendomsskatt)",
        securityDeposit: "Depositum",
        perMonth: "/måned",
        perWeek: "/uke",
        disclaimer: "Ansvarsfraskrivelse",
        energyCertificate: "Energimerke",
        pending: "Avventer",
        rating: "Klassifisering",
        presentedBy: "Presentert av",
        propertyDetails: "Boligdetaljer",
        reference: "Referanse",
        referenceShort: "Ref",
        unitUnavailable: "Ikke lenger tilgjengelig",
        availableUnits: "Ledige enheter og priser",
        availableUnitsShort: "Ledige enheter",
        unit: "Enhet",
        type: "Type",
        floors: "Etasjer",
        bedrooms: "Soverom",
        bathrooms: "Bad",
        surfaceArea: "Innvendig",
        price: "Pris",
        status: "Status",
        unitAvailable: "Ledig",
        unitReserved: "Reservert",
        unitSold: "Solgt",
        seeMore: "Se mer",
        seeLess: "Se mindre",
        floor: "Etasje",
        storeys: "Etasjer totalt",
        keyReady: "Innflyttingsklar",
        touristLicence: "Turistlisens",
        firstOccupationLicence: "Brukstillatelse",
        notKnown: "Ikke oppgitt",
        notProvided: "Ikke angitt",
        yes: "Ja",
        no: "Nei",
        mortgageAvailable: "Finansiering mulig",
        guaranteedRental: "Garantert utleie",
        sellBeforeCompletion: "Overdragelse av kontrakten før ferdigstillelse",
        sellBeforeCompletionYes: "Tillatt",
        sellBeforeCompletionNo: "Ikke tillatt",
        sellBeforeCompletionNotProvided: "Ikke oppgitt",
        reservation: "Reservasjon",
        contract: "Kontrakt",
        construction: "Bygging",
        completion: "Ferdigstillelse",
        co2: "CO2",
        energyConsumption: "Energiforbruk",
        co2PerYear: "kg CO2/år",
        kwhPerYear: "kWh/år",
        features: "Fasiliteter",
        viewDetails: "Se detaljer",
        hideDetails: "Skjul boligdetaljer",
        backToResults: "Resultater",
        viewProperty: "Se bolig",
        prevProperty: "Forrige",
        nextProperty: "Neste",
        viewAllFeatures: "Se alle fasiliteter",
        allFeatures: "Alle fasiliteter",
        infoOnRequest: "Informasjon på forespørsel",
        tbc: "Ikke oppgitt",
        featureCategoryLabels: { pool: "Basseng", views: "Utsikt", parking: "Parkering", kitchen: "Kjøkken", condition: "Tilstand", garden: "Hage" },
        featureQualifierFormat: "{value} {category}",
        location: "Beliggenhet",
        agencyInformation: "Informasjon om megleren",
        buyingCosts: "Kjøpsomkostninger",
        propertyPrice: "Boligpris:",
        priceNote: "**Prisen inkluderer ikke skatter eller kjøpsomkostninger.",
        estimatedPurchaseCosts: "Estimerte kjøpsomkostninger:",
        hide: "Skjul",
        showBreakdown: "Vis spesifikasjon av kjøpsomkostninger",
        purchaseCostBreakdown: "Spesifikasjon av kjøpsomkostninger",
        concept: "Post",
        application: "Beregning",
        rowTransferTax: "ITP (dokumentavgift, bruktbolig)",
        rowVat: "MVA (nybygg)",
        rowVatLand: "MVA",
        vatApplication: "10 % (4 % for subsidierte boliger)",
        rowStampDuty: "Stempelavgift (AJD)",
        rowNotary: "Notar",
        rowLandRegistry: "Eiendomsregister",
        officialTariff: "Offisiell sats",
        costRangeNotePrefix: "*Kjøperens samlede kostnader ligger vanligvis mellom",
        and: "og",
        ofPurchasePrice: "av kjøpesummen.",
        costApproxNote: "*De estimerte kjøpskostnadene er kun veiledende. De faktiske kostnadene kan variere avhengig av eiendommen og kjøperens forhold. Vi anbefaler å innhente profesjonell rådgivning for en nøyaktig beregning.",
        additionalInformation: "Tilleggsinformasjon",
        addInfoDocument: "*Forkortet informasjonsdokument tilgjengelig i henhold til det andalusiske dekretet 218/2005",
        addInfoNoFees: "*Kjøper betaler ikke meglerhonorar",
        formHeading: "Vil du vite mer om prisene og boligen?",
        firstName: "Fornavn",
        enterNumber: "Skriv inn nummer",
        email: "E-post",
        searchCountry: "Søk etter land eller landkode",
        noMatches: "Ingen treff",
        consent: "Ved å klikke på knappen samtykker du til behandlingen av personopplysningene dine i samsvar med personvernerklæringen, inkludert innsamling, lagring og bruk av opplysningene du oppgir for å kontakte deg og gi deg nødvendig informasjon.",
        send: "Send",
        contactUs: "Kontakt oss",
        yourMessage: "Din melding",
        agreeData: "Jeg samtykker til å oppgi opplysningene mine for å motta svar på min informasjonsforespørsel.",
        agreeContact: "Jeg ber om å bli informert og samtykker til å bli kontaktet av selskapet som er ansvarlig for prosjektet eller den aktuelle forhandleren, via kontaktopplysningene jeg frivillig oppgir til dette formålet.",
        reject: "Avslå",
        like: "Liker",
        liked: "Lagret",
        rejected: "Avslått",
        offerRejected: "Tilbud avslått",
        contact: "Kontakt",
        call: "Ring",
        calling: "Ringer",
        noPhone: "Ingen telefonnummer tilgjengelig",
        enquirySent: "Forespørsel sendt — vi kontakter",
        yourDetails: "opplysningene dine",
        respondedTo: "besvart",
        noProperties: "Ingen boliger å vise.",
        soldOutBody: "Eiendommene i dette tilbudet er solgt eller ikke lenger på markedet. Kontakt byrået for et oppdatert utvalg.",
        expiredTitle: "Denne tilbudslenken har utløpt",
        expiredBody: "Kontakt megleren for en oppdatert lenke for å se disse boligene.",
        unavailableTitle: "Tilbud utilgjengelig",
        unavailableBody: "Vi kunne ikke laste dette tilbudet. Lenken kan være ugyldig, eller tjenesten er midlertidig utilgjengelig — prøv igjen senere eller kontakt megleren.",
    },
    title: "{agencyName} s egenskaper",
    in: "in",
    propertiesFound: "eiendommer funnet",
    toDay: "I dag",
    days: "dager",
    week: "Uke",
    year: "År",
    month: "Måned",
    prev: "Forrige",
    next: "Neste",
    backToList: "Tilbake til listen",
    sorry: "Sorry , we",
    cantFind: "finner ikke",
    lookingFor: "siden du leter etter ...",
    thankYou: "TAKK FOR AT DU BESØKER VÅRE NETTSIDE",
    pleaseContact: "Kontakt agent for en ny URL.",
    ForSale: "SALG",
    ShortTermRental: "Kort leie",
    LongTermRental: "Lang husleie",
    showMore: "Show More",
    showLess: "Vis mindre",
    price: "Pris",
    pricePer: "Pris per",
    built: "Bygg",
    floorSpace: "Interiøret gulvplass",
    terrace: "Terrasse",
    garden: "Garden",
    plot: "Tomt",
    propTitle: '{subType} {searchType} på {location}',
    propTitleShort: '{subType} på {location}',
    notAvailable: "Ikke tilgjengelig",
    notFound: 'Siden ble ikke funnet',
    emptyProperties: "Ingen eiendommer ble funnet. Kontakt agent for mer informasjon.",
    linkExpired: "Oops, denne koblingen er utløpt. Kontakt din eiendomsmegler for å motta en oppdatert eiendomslenke.",
    newDevelopment: "Ny utvikling",
    agencyRaiiNo: "Byråets registreringsnummer",
    home: {
        verifyYourURLHere: "Bekreft URL-en din her. For å gjøre dette, logg inn på WhatsApp i nettleseren din, og kopier deretter URL-en fra WhatsApp til hit.",
        pasteUrlHere: "Lim inn URL her",
        verifyUrl: "Bekreft URL",
        whatIsPropertyViewer: "Hva er Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Dette nettstedet brukes av eiendomsmeglere til å sende eiendommer til sine kunder. Det er et produkt fra {resalesonlinecom} Hvis du er i tvil, snakk med agenten som sendte eiendomslisten din til deg.",
        howDoesItWork: "Hvordan fungerer det?",
        inThePast: "Tidligere sendte agenter PDF-dokumenter til sine kunder. Disse er imidlertid ikke enkle å vise på mange enheter. Derfor opprettet {propertyviewercom} slik at klienten lettere kan vise egenskaper som sendes til dem.",
        createAShortList: "Agenten oppretter en kort liste over egenskaper. Når de deler disse eiendommene med deg, vil du motta en kobling. Ved å klikke på denne linken vil vise deg egenskapene."
    },

    list: {
        propertyTitle: "Klikk her for å vise informasjon for denne egenskapen"
    },

    searchType: {
        ForSale: "for salg",
        ShortTermRental: "for korttidsleie",
        LongTermRental: "for langtidsleie",
    },

    rsStatus: {
        Available: "Tilgjengelig",
        Listing: "Oppføringen",
        UnderOffer: "Under tilbud",
        SaleAgreed: "Salg avtalt",
        OffMarket: "Utenfor markedet",
        Sold: "Solgt",
        Rented: "Leid"
    },

    details: {
        average: "Gjennomsnitt",
        averagePricesFor: "Gjennomsnittlige priser for",
        showFullER: "Vis full",
        thisProperty: "Denne eiendommen",
        infoNotAvailable: "Denne informasjonen er ikke tilgjengelig.",
        feesEnergyRating: "Gebyrer, energivurdering",
        fees: "Gebyrer",
        ibiFees: "IBI-avgifter",
        basuraTax: "Basura Skatt",
        communityFees: "Fellesskap avgifter",
        associatedCosts: "	Tilknyttede kostnader",
        energyRating: "Energiklassifisering",
        securityDeposit: "Depositum",
        energyCertificate: "Energiattest",
        energyCertificatePending: "Energisertifikatet venter",
        energyConsumption: "Energiforbruk",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per år",
        kwhPerYear: "kWh/m² per år",
        other: "Andre",
        buildYear: "Byggeår",
        forSale: "Til salgs",
        sold: "Solgt",
        longTerm: "Langsiktig",
        shortTermHigh: "Short term high",
        shortTermLow: "Kortsiktig lav",
        allFeatures: "Alle funksjoner",
        aproxLocation: "Omtrentlig plassering",
        listingAgent: "Oppføring agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Turistregistreringsnummer",
        agencyInformation: "Informasjon om byrå",
    },
};